module.exports = __webpack_public_path__ + "static/media/28DGC6.725191b2.jpg";